module.exports = __webpack_public_path__ + "assets/img/hero-subtitle-e589d2ed.png";